module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h4', [_vm._v("Thank you, your order has been placed. " + _vm._s(_vm.title))]), _vm._v(" "), _c('h6', [_vm._v(" Order Number: " + _vm._s(_vm.transId) + " ")]), _vm._v(" "), _c('h6', [_vm._v(" Total: $" + _vm._s(_vm.total / 100))]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.toCatalog
    }
  }, [_vm._v("Go to catalog")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5ecf640"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Transaction.vue
// module id = 327
// module chunks = 0